import { flow, get, isEqual } from 'lodash/fp'
import {
  hasForeignFundSummary as hasLstuForeignFunds,
  hasOverRiskFundSummary as hasLstuOverRiskFunds,
} from 'quick-quote/product-investment/fund-allocation/lstu/selectors'
import {
  hasForeignFundAllocation as hasRppForeignFunds,
  hasOverRiskFundAllocation as hasRppOverRiskFunds,
} from 'quick-quote/product-investment/fund-allocation/rpp/selectors'
import { createSelector } from 'reselect'

export const getAvailableFunds = (state) => state.investment.funds.availableFunds
export const hasValidEntryComponent = (state) =>
  flow(get('entryComponent.source'), isEqual('perfect-advice'))(state) ? true : false

export const _hasOverRiskFunds = (hasRppOverRiskFunds, hasLstuOverRiskFunds) =>
  hasRppOverRiskFunds || hasLstuOverRiskFunds

export const _hasForeignFunds = (hasRppForeignFunds, hasLstuForeignFunds) => hasRppForeignFunds || hasLstuForeignFunds

export const hasOverRiskFunds = createSelector(hasRppOverRiskFunds, hasLstuOverRiskFunds, _hasOverRiskFunds)

export const hasForeignFunds = createSelector(hasRppForeignFunds, hasLstuForeignFunds, _hasForeignFunds)
